@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../settings-page.module.less';

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background-color: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;

  .header {
    background: @settings-page--table--header--cell--background-color;
    color: @settings-page--table--header--cell--text-color;
    border-top: @settings-page--table--border;
    font-weight: @settings-page--table--header--cell--font-weight;
  }

  .cell {
    display: flex;
    height: 42px;
    align-items: center;
    padding: @settings-page--table--cell--padding;
    border-bottom: @settings-page--table--border;

    &:nth-of-type(3n-2) {
      border-left: @settings-page--table--border;
    }

    &:nth-of-type(3n) {
      border-right: @settings-page--table--border;
    }
  }
}

.insurance-provider-name {
  display: flex;
}

.insurance-provider-row-icon {
  height: 30px;
  width: 30px;
  min-width: 30px;
  margin-right: 5px;

  > img {
    height: 100%;
    width: 100%;
  }
}

.action {
  color: @settings-page--shipping-insurance-provider-link--text-color;

  &:hover {
    color: @settings-page--shipping-insurance-provider-link--hover--text-color;
    text-decoration: @settings-page--shipping-insurance-provider-link--hover--text-color underline;
    cursor: pointer;
  }
}

.loading {
  width: 42px;
}
